import axios from "axios";
import { getClientToken } from "../helper/clientAuth";

export const Api = axios.create({
  baseURL: process.env.REACT_APP_API_KEY,
  headers: {
    "Content-Type": "application/json",
  },
});

Api.interceptors.request.use(async function (config) {
  // Add Authorization header
  const usesPublicAuth =
    config.url?.includes("/api/client/login") ||
    config.url?.includes("/api/client/register") ||
    config.url?.includes("/api/client/verify-email");
  const token = usesPublicAuth
    ? process.env.REACT_APP_API_TOKEN
    : getClientToken() || process.env.REACT_APP_API_TOKEN;
  if (!config.headers["Authorization"]) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }

  // Add language header
  const lang = localStorage.getItem("i18nextLng") || "en";
  config.headers["Accept-Language"] = lang;

  return config;
});


export const SecondaryApi = axios.create({
  baseURL: process.env.REACT_APP_SECONDARY_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

SecondaryApi.interceptors.request.use(async function (config) {
  // Add Authorization header
  const usesPublicAuth =
    config.url?.includes("/api/client/login") ||
    config.url?.includes("/api/client/register") ||
    config.url?.includes("/api/client/verify-email");
  const token = usesPublicAuth
    ? process.env.REACT_APP_API_TOKEN
    : getClientToken() || process.env.REACT_APP_API_TOKEN;
  if (!config.headers["Authorization"]) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }

  // Add language header
  const lang = localStorage.getItem("i18nextLng") || "en";
  config.headers["Accept-Language"] = lang;

  return config;
});

export const ThirdApi = axios.create({
  baseURL: process.env.REACT_APP_THIRD_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

ThirdApi.interceptors.request.use(async function (config) {
  const usesPublicAuth =
    config.url?.includes("/api/client/login") ||
    config.url?.includes("/api/client/register") ||
    config.url?.includes("/api/client/verify-email");

  const token = usesPublicAuth
    ? process.env.REACT_APP_API_TOKEN
    : getClientToken() || process.env.REACT_APP_API_TOKEN;

  if (!config.headers["Authorization"]) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }

  const lang = localStorage.getItem("i18nextLng") || "en";
  config.headers["Accept-Language"] = lang;

  return config;
});
